<script lang="ts" setup>
import type { TreeViewDataObject } from "@lxc/app-device-common";
import LxcError from "~/core/models/LxcError.class";
import { useParseCertificateFromString } from "~/modules/certificate/composables/useCertificateParse";
import type { CertificateChainLink } from "~/modules/certificate/models/CertificateChainLink.interface";
import type { SubjectAlternativeName } from "~/modules/certificate/models/SubjectAlternativeName.interface";

const props = defineProps<{
  chainLinks?: CertificateChainLink[];
  leafSubjectAlternativeNames?: SubjectAlternativeName[];
}>();

const { getTreeviewDataFromChainLinks } = useParseCertificateFromString();

/**
 * return the treeview data
 */
const treeViewData: ComputedRef<TreeViewDataObject[] | LxcError> = computed(
  () => {
    if (props.chainLinks) {
      return getTreeviewDataFromChainLinks(
        props.chainLinks,
        props.leafSubjectAlternativeNames ?? [],
      );
    } else {
      return [];
    }
  },
);
</script>

<template>
  <div v-if="LxcError.check(treeViewData)">
    <error-component :error="treeViewData" />
  </div>
  <div
    v-else-if="treeViewData"
    class="bg-gray-50 border border-solid border-gray-300 p-1 overflow-x-hidden"
  >
    <lxc-tree-view :key="treeViewData" :data="treeViewData" :expanded="true" />
  </div>
</template>
